import styled from "styled-components";

export const RangeDatePickerStyled = styled.div`
  .ant-picker {
    width: 300px;
    max-height: 48px;
    height: 48px;
    background-color: #f5f5f5;
    border-radius: 12px;
    input {
      font-size: 12px;
    }
  }
`;
